customElements.get('next-drop-countdown') || customElements.define('next-drop-countdown', class extends HTMLElement {
  constructor() {
    super();
    this.daysEl = this.querySelector('.js-next-drop-countdown-days');
    this.hoursEl = this.querySelector('.js-next-drop-countdown-hours');
    this.minutesEl = this.querySelector('.js-next-drop-countdown-minutes');
    this.secondsEl = this.querySelector('.js-next-drop-countdown-seconds');
    this.intervalId = null;
    this.tick = this.tick.bind(this);
  }

  connectedCallback() {
    const target = this.dataset.target;
    this.targetTime = target ? new Date(target).getTime() : NaN;

    if (Number.isNaN(this.targetTime)) return;

    this.tick();
    this.intervalId = window.setInterval(this.tick, 1000);
  }

  disconnectedCallback() {
    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  tick() {
    const remainingMs = Math.max(0, this.targetTime - Date.now());

    const totalSeconds = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.render(days, hours, minutes, seconds);

    if (remainingMs <= 0 && this.intervalId !== null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  render(days, hours, minutes, seconds) {
    const pad = (value) => String(value).padStart(2, '0');

    if (this.daysEl) this.daysEl.textContent = pad(days);
    if (this.hoursEl) this.hoursEl.textContent = pad(hours);
    if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
    if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
  }
});
